import {jsclj, keyword, resolveGoogExport} from 'dgetz/tsclj'
import React from 'react'

const maybeKeyword = (s) => {
  return (typeof s === 'string') ? keyword(s) : s
}

interface ModalProps {
  show?: boolean;
  backgroundColor?: string;
  horizontallyCentered?: boolean;
  roundedCorners?: boolean;
  width?: string;
  height?: string;
  title?: string;
  onDismiss?: Function;
  closeable?: boolean;
  children: React.ReactNode;
}

export function Modal(props : ModalProps) {
  let {modal} = resolveGoogExport('ladder.ux.modal')
  return modal(jsclj({
    'show?': props.show,
    'background-color': maybeKeyword(props.backgroundColor),
    'horizontally-centered?': props.horizontallyCentered,
    'rounded-corners?': props.roundedCorners,
    'width': maybeKeyword(props.width),
    'height': maybeKeyword(props.height),
    'title': props.title,
    'on-dismiss': props.onDismiss,
    'closeable': props.closeable,
  }), props.children)
}
